import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { VerticalTimelineElement } from "react-vertical-timeline-component";
import { Button, Card } from "reactstrap";
import pdfLogo from "../../../../assets/images/logo/pdfImage.png";
import { CourseDto } from "../../../../models/courseDto";
import { TypeCourse } from "../../../../models/typeCourseDto";
import hasRoles from "../../../../security/hasRoles";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import styles from "./course.module.scss";
import { translate } from "react-switch-lang";

const CoursesTimeLine: React.FC<{ course: CourseDto; getCourseTimeString: any; getStepIcon: any; handleClickOpenModalViewer: any;t: (key: string) => string }> = ({
  course,
  getCourseTimeString,
  getStepIcon,
  handleClickOpenModalViewer,
  t
}) => {
  const { keycloak } = useKeycloak();
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const httpClient = useHttpClient(keycloak.authenticated);
  const [isCourseFinished, setIsCourseFinished] = useState(false);

  useEffect(() => {
    async function fetch() {
      getCourseStatus();
    }
    fetch();
    // eslint-disable-next-line
  }, [isCourseFinished]);

  async function getCourseStatus() {
    if (course && course.id) {
      const response = await httpClient.current.get(`/course/isCourseFinished/${course.id}`);
      setIsCourseFinished(response.data);
    }
  }

  return (
    <VerticalTimelineElement
      className={styles["timeline_element"]}
      contentStyle={{ padding: "0px", backgroundColor: "transparent", borderRadius: "10px" }}
      key={course.id}
      animate={true}
      date=""
      icon={getStepIcon(TypeCourse[course.courseType])}
    >
      <Card className={styles["course_box"]}>
        <div className={styles["course_header"]}>
          <span className={styles["course_duration"]}>{getCourseTimeString(course.courseHours, course.courseMinutes)}</span>
        </div>
        <div className={styles["course_content"]}>
          {course.courseType === "PDF" && (
            <div className={styles["pdf_section"]}>
              <h5 className={styles["course_title"]}>{course.title}</h5>
              <div className={styles["pdf_display"]}>
                <img src={pdfLogo} className={styles["pdf_logo"]} alt="PDF Icon" />
              </div>
            </div>
          )}
          {course.courseType === "VIDEO" && (
            <div className={styles["video_section"]}>
              <h5 className={styles["course_title"]}>{course.title}</h5>
              <div className={styles["video_thumbnail"]}>
                <video width="100%" height="auto" controls>
                  <source src={course?.supportUrl + "/download"} type="video/mp4" />
                </video>
              </div>
            </div>
          )}
          <div className={styles["button_overlay"]}>
            <Button className={styles["support_button"]} onClick={() => handleClickOpenModalViewer(course)}>
              {hasRoleAdmin || isCourseFinished ? t("view_the_document") : t("training_path_start")}
            </Button>
          </div>
        </div>
      </Card>
    </VerticalTimelineElement>
  );
};

export default translate(CoursesTimeLine);
